import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { API_BASE_URL } from "../../config";

export default function UpdateForgotPassword() {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const location = useLocation();
  const securityToken = location.state?.securityToken;
  const navigate = useNavigate();
  // console.log("security token", securityToken);
  const email = location.state?.email;
  // console.log("Received Email:", email);
  useEffect(() => {
     if (!email && !securityToken) {
       navigate("/forgotpassword");
     }
   }, [email, securityToken,navigate]);
 
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdateForgotPassword = async (e) => {
    e.preventDefault();
    const loadingToast=toast.loading("please wait ")
    try {
      const data = new FormData();
      data.append("email", email)
      data.append("newPassword", formData.newPassword);
      data.append("confirmPassword", formData.confirmPassword);
      data.append("securityToken", securityToken)
      const response = await axios.post(
        `${API_BASE_URL}/api/admin/admin-changeForgot-password`,
        data,
       
      );
      // console.log("jhgfcx ", response);
      if (response.data.statusCode === 200) {
        toast.success("Password Updated Successfully");
        navigate("/auth/")
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Invalid Error! Please try again later");
    }
    finally{
      toast.dismiss(loadingToast)
    }
  };
  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          New Password
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your new password !
        </p>
        <form className="space-y-4" onSubmit={handleUpdateForgotPassword}>
          <input
            type="password"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
            placeholder="New Password"
            className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none border-gray-200 dark:!border-white/10 dark:text-white"

          />

          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            placeholder="Confirm Password"
            className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none border-gray-200 dark:!border-white/10 dark:text-white"

          />

           <button 
           type="submit"
           className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
          Submit
        </button>
        </form>
       

      </div>
    </div>
  );
}
